import { AppTheme, lightCompactTheme } from './themes'

export * from './themes'
export default lightCompactTheme

declare module 'styled-components' {
  export interface DefaultTheme extends AppTheme {}
}
